module.exports = __webpack_public_path__ + "officialStatic/img/product-dl.9c85b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-dl.png
// module id = Wrw3
// module chunks = 0